module.exports = __webpack_public_path__ + "static/media/orientation.7611e0c8.jpg";